<template>
  <v-card>
    <v-card-title primary-title>
      Ta bort underkategori: {{ categories[uuid].name }}
    </v-card-title>

    <v-card-text>
      Är du säker på att du vill ta bort underkategorin?
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="onClose">
        Avbryt
      </v-btn>
      <v-btn type="submit" color="error" text @click="onConfirm">
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DELETE_CATEGORY from '@/gql/categories/mutations/DeleteCategory.gql'
import { get } from 'vuex-pathify'

export default {
  name: 'MasterdataSubCategoriesDelete',

  props: {
    uuid: String,
  },

  computed: {
    categories: get('categories/data'),
  },

  methods: {
    async onConfirm() {
      this.deleteCategory()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    deleteCategory() {
      return this.$apollo.mutate({
        mutation: DELETE_CATEGORY,
        variables: {
          uuid: this.uuid,
        },

        update: () => {
          const updatedCategories = Object.values(this.categories)
            .filter(x => x.uuid !== this.uuid)
            .reduce((a, b) => {
              a[b.uuid] = b
              return a
            }, {})
          this.$store.set('categories/data', updatedCategories)
        },
      })
    },
  },
}
</script>
